module.exports = __webpack_public_path__ + "static/media/diana_vorstellung0600.135619c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/standalone/diana_vorstellung0600.jpg
// module id = 177
// module chunks = 0